/** Import Dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import {IMetrics} from '../core/models/metrics';
import {metricsEvent} from '../core/classes/api';
import '../styles/splashpage.scss';

/** Props interface */
interface IData {
     data: {
          campaign:string;
          type:string;
          backgroundLink: string,
          class: string,
          content: {
               title: string,
               subTitle: string,
               body: string,
               footer: {
                    type: string,
                    subType: string,
                    button: {
                         text: string,
                         link: string
                    }
               }
          },
          showTime: number
     },
     show: string
}

/** Component */
class SplashPage extends React.Component<IData> {
     state: IData;
     constructor(props: IData) {
          super(props);
          this.state = {
               ...props
          };
          this.close = this
               .close
               .bind(this);
          this.countDown = this
               .countDown
               .bind(this);
          this.renderHtml = this
               .renderHtml
               .bind(this);
          this.metricHandler = this.metricHandler.bind(this);
     }

     componentDidMount() {
          this.countDown(this.state.data.showTime);
     }

     public metricHandler(){
          const event:IMetrics = {
               category: this.props.data.type,
               referer: window.location.href,
               campaign: this.props.data.campaign,
               action: 'cta taken'
          }
          metricsEvent(event);
     }

     public renderHtml(html: any) {
          return { __html: html }
     }

     public close() {
          const event:IMetrics = {
               category: this.props.data.type,
               referer: window.location.href,
               campaign: this.props.data.campaign,
               action: 'dismiss splaspage - close button'
          }
          metricsEvent(event);
          this.setState({ show: 'closed' });
     }

     public countDown(time: number) {
          const int = setInterval(() => {
               this.setState({ timeLeft: time });
               if (time === 0) {
                    clearInterval(int);
                    this.componentWillUnmount();
                    const event:IMetrics = {
                         category: this.props.data.type,
                         referer: window.location.href,
                         campaign: this.props.data.campaign,
                         action: 'dismiss splashpage - auto'
                    }
                    metricsEvent(event);
               }
               time--;
          }, 1000);
     }

     componentWillUnmount() {
          const element = document.getElementById('directresponse-module') as HTMLElement;
          ReactDOM.unmountComponentAtNode(element);
     }

     public render() {
          return (
               <div
                    className={'splashPage ' + this.state.show}
                    style={{
                         backgroundImage: 'url(' + this.state.data.backgroundLink + ')'
                    }}>
                    <a href="../" onClick={this.close} className="skip">Skip</a>
                    <div className="row main-content">
                         <div className="title-content">
                              <p>
                                   <span
                                        className="title"
                                        dangerouslySetInnerHTML={this.renderHtml(this.state.data.content.title)} />&nbsp;<span className="subTitle">{this.state.data.content.subTitle}</span>
                              </p>
                              <img className="yellow-text-image" src="https://0b9aafecab229788ebf1-90f622f94aeb4d165ef7469777c28f31.ssl.cf2.rackcdn.com/direct-response/05-19/dr-splashpage-dep1.png" alt="text-yellow" />
                              <img className="pancan-20-logo" src="https://0b9aafecab229788ebf1-90f622f94aeb4d165ef7469777c28f31.ssl.cf2.rackcdn.com/direct-response/05-19/dr-splashpage-dep2.png" alt="pancanlogo 20th anniversary" />
                         </div>
                         <div className="col-md-6">
                              <p className="body" dangerouslySetInnerHTML={this.renderHtml(this.state.data.content.body)} />
                         </div>
                         <div className="col-md-6 mobile-gutter">
                              <div className="text-center">
                                   <div className="button-holder">
                                        <a
                                             onClick={this.metricHandler}
                                             href={this.state.data.content.footer.button.link}
                                             className="button-exec mustard-bck">{this.state.data.content.footer.button.text}</a>
                                        <a
                                             onClick={this.metricHandler}
                                             href={this.state.data.content.footer.button.link}
                                             className="button-exec mustard-bck">{this.state.data.content.footer.button.text}</a>
                                   </div>
                                   {/* <p className="type">{this.state.data.content.footer.type}</p>
                                   <p className="sub-type">{this.state.data.content.footer.subType}</p> */}

                                   <a href="../" className="text-white" onClick={this.close}>No, thanks</a>
                              </div>
                         </div>
                    </div>
               </div>
          );
     }
}

export default SplashPage;